import { useCallback, useContext, useEffect } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { WorkflowV1 } from "../shared/interfaces/WorkflowV1";
import { useDataLoadingReducer } from "./DataLoadingReducer";

export function useWorkflowsBySubstationAndCustomer(substationId?: number, customerId?: number) {
  const [state, dispatch] = useDataLoadingReducer<WorkflowV1[]>([]);
  const apiContext = useContext(ApiContext);

  const fetchData = useCallback(() => {
    dispatch({ type: "loading" });
    substationId &&
      customerId &&
      apiContext.workflowApis
        .getWorkflowsBySubstationAndCustomer(substationId, customerId)
        .then((response) => {
          if (response instanceof Error) {
            dispatch({ type: "errored", message: response.message });
          } else {
            dispatch({ type: "loaded", data: response });
          }
        })
        .catch((error) => {
          dispatch({ type: "errored", message: error });
        });
  }, [dispatch, substationId, customerId, apiContext.workflowApis]);

  useEffect(() => {
    substationId && customerId && fetchData();
  }, [customerId, fetchData, substationId]);

  return { ...state, refreshData: fetchData };
}
